import { Grid } from "@mui/material";
import { useEffect } from "react";
import {
  Control,
  FieldErrors,
  // UseFormRegister,
  UseFormReset
} from "react-hook-form";

import config from "../../../Config/clientConfig.json";
import WSSelectField from "../../../Components/Select/WSSelect";
import WSHiddenField from "../../../Components/HiddenField/WSHiddenField";
// import { callAPI, Method } from "../commonFunctions/CommonFunctions";
interface StatusProps {
  control: Control<any>;
  errors: FieldErrors;
  contact?: boolean;
  id: any;
  reset: UseFormReset<any>;
  rowId?: any
}
export const UpdateStatus: React.FC<StatusProps> = ({
  control,
  id,
  reset,
  contact = false,
  rowId,
}) => {

  // const [status, setStatus] = useState<any>([]);

  useEffect(() => {
    reset();
  }, [id, reset]);

  // useEffect(() => {
  //   const fetchStatus = async () => {
  //     try {
  //       const response: any = await callAPI(
  //         "lead-status",
  //         Method.GET
  //       );
  //       setStatus(response.data);
  //     } catch (error) {
  //       console.error("failed to retrieve data", error);
  //     }
  //   };

  //   fetchStatus();
  // }, []);

  return (
    <Grid>
      <Grid sx={{ padding: "20px", position: "relative", margin: "0", marginTop: '3rem' }} container spacing={2}>
        <Grid item xs={12} sm={12}>
          <WSSelectField
            options={contact ? config.contactStatusConfig.staticOptionData : config.leadStatusConfig.staticOptionData}
            rules={{ required: true }}
            // {...register("newStatus")}
            id="newStatus"
            control={control}
            label="Status"
            name="newStatus"
          />
        </Grid>
        <WSHiddenField control={control} name="leadId" defaultValue={rowId} />
        {/* <Grid item xs={12} sm={6}>
          <WSSelectField
            id="statusId"
            label={"Select Status"}
            name="status"
            control={control}
            rules={{ required: "please select a status" }}
            options={status.map((value: any) => ({
              label: value.status,
              value: value.id
            }))}
          />
        </Grid> */}
      </Grid>
    </Grid>
  );
};
